export class ObjectHelper {

    // Get all string values leafs
    public static fetchValuesRecursive(data: any): string[] {
        let leafs: string[] = []

        if (typeof data === 'string') {
            return [data]
        } else if (Array.isArray(data)) {
            for (let key in data) {
                leafs = leafs.concat(this.fetchValuesRecursive(data[key]))
            };
        } else if (typeof data === "object") {
            let keys = Object.keys(data)
            for (let [,key] of Object.entries(keys)) {
                leafs = leafs.concat(this.fetchValuesRecursive(data[key]))
            }
        }

        return  leafs
    }

    public static deleteSpecificFilterValue(filterKey: string, formValues: any) {
        const prev = formValues.filter ?? {};
        // filterKey : clé à supprimer du tableau 
        const { [filterKey]: _, ...rest } = prev; // le "_" sert à ignorer la valeur de la clé supprimée
        return rest;                              
    }

    public static deleteSpecificFilterFromList(idx: number, filters: any[]): any[] {
        const newFilters = [...filters];
        newFilters.splice(idx, 1);
        return newFilters;
    }

    public static removeFormFilterFields(filterFields: string[], externalFilters: any) {
        return filterFields.filter(field => {
            let filterFieldCode = field.split('__EQ__');
            return !externalFilters[filterFieldCode[0]];
        });
    }

    public static removeTabsFilterFields(filterFields: string[], externalFilters: any) {
        return filterFields.filter(field => {
            let filterFieldCode = field.split('__EQ__');
            return externalFilters[filterFieldCode[0]];
        });
    }

    public static removeFilterFromFilterFields(filterFields: string[], filterKey: string): string[] {
        return filterFields.filter(field => !field.startsWith(filterKey + '__EQ__'));
    }

    public static extractFilterFieldFromFilterFields(filterFields: string[], filterKey: string): string | undefined {
        return filterFields.find(field => field.startsWith(filterKey + '__EQ__'));
    }

    public static extractValueFromFilterField(field: string): string {
        let filterFieldCode = field.split('__EQ__');
        return filterFieldCode[1] ? filterFieldCode[1].replace(/[\[\]]/g, "") : "";
    }

    public static extractFilterFromFilterField(field: string): string {
        let filterFieldCode = field.split('__EQ__');
        return filterFieldCode[0];
    }
}